import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import GUI from 'lil-gui'
//meshEdges
import { BufferGeometry, EdgesGeometry } from 'three';
import { mergeAttributes } from 'three/addons/utils/BufferGeometryUtils.js';

   // Variables for mouse control
   let isDragging = false;
   let isPanning = false;
   let previousMousePosition = { x: 0, y: 0 };



class MeshEdgesGeometry extends BufferGeometry {

	constructor( object, thresholdAngle = 10) {

		super();

		object.updateWorldMatrix( true, true );

		var position = this.extractEdges( object, thresholdAngle );

		this.setAttribute( 'position', position );

	} // MeshEdgesGeometry.constructor


	// extract edges - each edge is individual segment
	// return position buffer
	extractEdges( object, thresholdAngle ) {

		var attributes = [];

		object.traverse( child => {

			if ( child.geometry ) {

				var geo = new EdgesGeometry( child.geometry, thresholdAngle );
				var pos = geo.getAttribute( 'position' );

				attributes.push( pos.applyMatrix4( child.matrixWorld ) );

			} // if

		} ); // object.traverse

		if ( attributes.length == 0 ) {

			throw 'MeshEdgesGeometry: No edges found';

		}

		return mergeAttributes( attributes );

	} // MeshEdgesGeometry.extractEdges

} // MeshEdgesGeometry


export { MeshEdgesGeometry };

/**
 * Base
 */
// Debug
//const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')
loadSketchUpLogo()

function loadSketchUpLogo(){
// Scene
const scene = new THREE.Scene()

const gltfloader = new GLTFLoader()

gltfloader.load(
    '/models/SketchUp/SketchUpLogo.gltf',
    (gltf) =>
    {
        scene.add(gltf.scene)
        var edges = new THREE.LineSegments(
        new MeshEdgesGeometry( gltf.scene.children[0] ),
        new THREE.LineBasicMaterial( {color: 0x222222} )
                )
        scene.add(edges)

    }
)


/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2)
scene.add(ambientLight)

const light = new THREE.PointLight(0xffffff, 50, 100);
light.position.set(2, 2, 2);
scene.add(light);

const directionalLight = new THREE.DirectionalLight(0xffffff, 1.8)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
//scene.add(directionalLight)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(2, 2, 2)

scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0,0.5, 0)
controls.maxPolarAngle = Math.PI
controls.enableDamping = true;
controls.zoomToCursor = true;

controls.saveState()
controls.mouseButtons = {
	MIDDLE: THREE.MOUSE.ROTATE,
	LEFT: null,
	RIGHT: null
}
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( 0xcccccc);







/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    controls.update()
    
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

document.addEventListener('keydown', function(event) {
    if (event.key === 'z' || event.key === 'Z') { // Check for 'z' key
        if (event.shiftKey) {
        controls.reset()
        }
    }
  });
}
//END Load Logo

function loadSketchUpModel() {


// code to be executed
const loading = document.getElementById('loading');
loading.style.display = 'block'; 
// Scene
const scene = new THREE.Scene()

const gltfloader = new GLTFLoader()






gltfloader.load(
    
    '/models/SketchUp/model.gltf',
    (gltf) =>
    {
        scene.add(gltf.scene)
        var edges = new THREE.LineSegments(
        new MeshEdgesGeometry( gltf.scene.children[0] ),
        new THREE.LineBasicMaterial( {color: 0x222222} )
                )
        scene.add(edges)

        loading.style.display = 'none';  
})



   // Variables for mouse control
   let isDragging = false;
   let isPanning = false;
   let previousMousePosition = { x: 0, y: 0 };


/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2)
scene.add(ambientLight)

const light = new THREE.PointLight(0xffffdd, 1000, 100);
light.position.set(2, 10, 2);
scene.add(light);

const directionalLight = new THREE.DirectionalLight(0xffffff, 10)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
//scene.add(directionalLight)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(8, 2, 1)

scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(.3,.3, -3)
controls.maxPolarAngle = Math.PI
controls.enableDamping = true
controls.zoomToCursor = true;
controls.saveState()
controls.mouseButtons = {
	MIDDLE: THREE.MOUSE.ROTATE,
	LEFT: null,
	RIGHT: null
}
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( 0x9bd3ff);

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    controls.update()
    
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

document.addEventListener('keydown', function(event) {
    if (event.key === 'z' || event.key === 'Z') { // Check for 'z' key
        if (event.shiftKey) {
        controls.reset()
        }
    }
  });
}

//END Load House

function loadMockup(){
    // Scene
    const scene = new THREE.Scene()
    
    const gltfloader = new GLTFLoader()
    
    gltfloader.load(
        '/models/SketchUp/mockup.gltf',
        (gltf) =>
        {
            scene.add(gltf.scene)
            var edges = new THREE.LineSegments(
            new MeshEdgesGeometry( gltf.scene.children[0] ),
            new THREE.LineBasicMaterial( {color: 0x222222} )
                    )
            scene.add(edges)
    
        }
    )
    
    
    /**
     * Lights
     */
    const ambientLight = new THREE.AmbientLight(0xffffff, 2)
    scene.add(ambientLight)
    
    const light = new THREE.PointLight(0xffffff, 50, 100);
    light.position.set(2, 2, 2);
    scene.add(light);
    
    const directionalLight = new THREE.DirectionalLight(0xffffff, 1.8)
    directionalLight.castShadow = true
    directionalLight.shadow.mapSize.set(1024, 1024)
    directionalLight.shadow.camera.far = 15
    directionalLight.shadow.camera.left = - 7
    directionalLight.shadow.camera.top = 7
    directionalLight.shadow.camera.right = 7
    directionalLight.shadow.camera.bottom = - 7
    directionalLight.position.set(5, 5, 5)
    //scene.add(directionalLight)
    
    /**
     * Sizes
     */
    const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
    }
    
    window.addEventListener('resize', () =>
    {
        // Update sizes
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight
    
        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()
    
        // Update renderer
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })
    
    /**
     * Camera
     */
    // Base camera
    const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
    camera.position.set(2, 2, 2)
    
    scene.add(camera)
    
    // Controls
    const controls = new OrbitControls(camera, canvas)
    controls.target.set(0,0.5, 0)
    controls.maxPolarAngle = Math.PI
    controls.enableDamping = true;
    controls.zoomToCursor = true;
    
    controls.saveState()
    controls.mouseButtons = {
        MIDDLE: THREE.MOUSE.ROTATE,
        LEFT: null,
        RIGHT: null
    }
    /**
     * Renderer
     */
    const renderer = new THREE.WebGLRenderer({
        canvas: canvas
    })
    renderer.shadowMap.enabled = true
    renderer.shadowMap.type = THREE.PCFSoftShadowMap
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.setClearColor( 0xcccccc);
    
    
    
    
    
    
    
    /**
     * Animate
     */
    const clock = new THREE.Clock()
    let previousTime = 0
    
    const tick = () =>
    {
        const elapsedTime = clock.getElapsedTime()
        const deltaTime = elapsedTime - previousTime
        previousTime = elapsedTime
    
        // Update controls
        controls.update()
        
        // Render
        renderer.render(scene, camera)
    
        // Call tick again on the next frame
        window.requestAnimationFrame(tick)
    }
    
    tick()
    
    document.addEventListener('keydown', function(event) {
        if (event.key === 'z' || event.key === 'Z') { // Check for 'z' key
            if (event.shiftKey) {
            controls.reset()
            }
        }
      });
    }
    //END Load Mockup


 // Mouse events for rotation and panning control
document.addEventListener('mousedown', (event) => {
    if (event.button === 1) { // Middle mouse button
        if (event.shiftKey) {
            isPanning = true;
            document.body.classList.add('pan-cursor');
    
        } else {
            isDragging = true;
            document.body.classList.add('orbit-cursor');
        }
    }
});


document.addEventListener('mouseup', (event) => {
    if (event.button === 1) {
        isDragging = false;
        isPanning = false;
        document.body.classList.remove('orbit-cursor');
        document.body.classList.remove('pan-cursor');
    }
});
 

  document.querySelector('#open-close1').addEventListener('click', () => {
    document.querySelector('.hidden1').classList.toggle('shown');
    document.querySelector('.hidden2').classList.remove('shown');

});

  document.querySelector('#open-close2').addEventListener('click', () => {
    document.querySelector('.hidden2').classList.toggle('shown');
    document.querySelector('.hidden1').classList.remove('shown');
});

document.querySelector('#SketchUpLogoModel').addEventListener('click', () => {
    loadSketchUpLogo();
    document.querySelector('.hidden2').classList.remove('shown');
    });

document.querySelector('#TFHouse').addEventListener('click', () => {
    loadSketchUpModel();
    document.querySelector('.hidden2').classList.remove('shown');
});

document.querySelector('#MockupModel').addEventListener('click', () => {
    loadMockup();
    document.querySelector('.hidden2').classList.remove('shown');
    });